import React from "react";

function ZommedImage({ style, src, srcSet, altText, className }) {
  return (
    <div className="w-100">
      <div
        className={`image-animation image-animation--from-default image-animation--to-center image-animation--to-opacity ${className}`}
      >
        <div className="rimage" style={style}>
          <img
            src={src}
            loading="lazy"
            className="rimage__img rimage__img--cover rimage__img--fade-in lazyload"
            srcSet={srcSet}
            alt={altText}
          />
        </div>
      </div>
    </div>
  );
}

ZommedImage.propTypes = {};

export default ZommedImage;
